import type { Feature } from '@getstep/proto/feature'
import { useStores } from '@lib/store/useStores'
import { useEffect } from 'react'

export const useOverrideFeature = (feature: Feature, enabled: boolean) => {
    const { featureOverrideStore } = useStores()

    useEffect(() => {
        featureOverrideStore.overrideFeature(feature, enabled)
    }, [enabled, feature, featureOverrideStore])
}
